import { CaretDownOutlined } from '@vindr/icons';
import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { Input, Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FILTER_TYPE } from './constants';

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');
  const institutions = useGetInstitutions({ offset: 0, limit: 100 })?.data?.data || [];

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px] max-w-full"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) =>
          handleOnChangeFilter(params, key, (event?.target as HTMLInputElement)?.value, true)
        }
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Institution Name'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Select
            size="small"
            mode="multiple"
            allowClear
            disabled
            maxTagCount="responsive"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select')}
            className="select-dropdown-light w-[200px] max-w-full"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
            value={params[FILTER_TYPE.INSTITUTION] || []}
            filterOption={(input, option) =>
              String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              option.key.toLowerCase().includes(input.toLowerCase())
            }
          >
            {institutions
              ? institutions.map((it, idx) => (
                  <Select.Option key={idx} value={it?.id}>
                    {it?.name}
                  </Select.Option>
                ))
              : null}
          </Select>
        ),
      },
      {
        text: t('Patient ID'),
        key: FILTER_TYPE.PATIENT_ID,
        component: InputItem(params, FILTER_TYPE.PATIENT_ID),
      },
      {
        text: t('Visit ID'),
        key: FILTER_TYPE.VISIT_ID,
        component: InputItem(params, FILTER_TYPE.VISIT_ID),
      },
      {
        text: t('Patient Name'),
        key: FILTER_TYPE.PATIENT_NAME,
        component: InputItem(params, FILTER_TYPE.PATIENT_NAME),
      },
    ],
    [t, params, institutions, handleOnChangeFilter]
  );
};

export default useSearchOptions;
